import { render } from "./ItemSpacer.vue?vue&type=template&id=780fa2d4&scoped=true"
import script from "./ItemSpacer.vue?vue&type=script&lang=js"
export * from "./ItemSpacer.vue?vue&type=script&lang=js"

import "./ItemSpacer.vue?vue&type=style&index=0&id=780fa2d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-780fa2d4"]])

export default __exports__